import React from "react";

export const protectedRoutes = [
  {
    key: "Dashboard",
    path: "/dashboard",
    component: React.lazy(() => import("../../views/dashboard-view/index")),
  },
  {
    key: "Orders",
    path: "/dashboard/orders",
    component: React.lazy(() =>
      import("../../views/dashboard-view/OrdersView")
    ),
  },
  {
    key: "Subscriptions",
    path: "/dashboard/subscriptions",
    component: React.lazy(() =>
      import("../../views/dashboard-view/SubscriptionsView")
    ),
  },
  // vercel
  {
    key: "Athletes",
    path: "/athletes",

    component: React.lazy(() => import("../../views/athletes-view/index")),
  },
  {
    key: "Athletes",
    path: "/transactions",
    component: React.lazy(() => import("../../views/transactionTable/index")),
  },
  {
    key: "Athletes",
    path: "/athlete/commission-tier/:id",
    component: React.lazy(() =>
      import("../../views/AthleteCommissionTierView/index")
    ),
  },
  {
    key: "Athletes",
    path: "/feature/commission-tiers",
    component: React.lazy(() =>
      import("../../views/CommissionTiersView/index")
    ),
  },
  {
    key: "Athletes",
    path: "/feature/commission-tiers/create",
    component: React.lazy(() =>
      import("../../views/CommissionTiersView/CreateCommissionTier")
    ),
  },
  {
    key: "Athletes",
    path: "/feature/commission-tiers/update/:id",
    component: React.lazy(() =>
      import("../../views/CommissionTiersView/UpdateCommissionTier")
    ),
  },
  {
    key: "User",
    path: "/users",

    component: React.lazy(() => import("../../views/users-view/index")),
  },
  {
    key: "Settings",
    path: "/settings",
    component: React.lazy(() => import("../../views/settings-view/index")),
  },
  {
    key: "discipline",
    path: `/feature/discipline`,
    component: React.lazy(() => import("../../views/discipline/index")),
  },
  {
    key: "interest",
    path: `/feature/interest`,
    component: React.lazy(() => import("../../views/interest/index")),
  },
];

export const publicRoutes = [
  {
    key: "",
    path: "/",
    component: React.lazy(() => import("../../views/signin-view/index")),
  },
];
